import { EmphasisTheme } from '@/components/Emphasis/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Emphasis = GenericSlot({ as: 'em', theme: EmphasisTheme });
